/**
 * TODO: disable "Save Current View...":
 * • if no preset has been loaded
 * • or if grid has not been modified
 * TODO: disable "Reset View" if preset hasn't been loaded
 */
import * as React from 'react'
import { PrimeButton } from 'components-design-system'
import PropTypes from 'prop-types'
import './PresetFooterActions.scss'

const PresetFooterActions = ({
  disableSave,
  onOpenModal,
  onResetPreset,
}) => {
  return <div className="presets-footer-actions">
    {onOpenModal &&
      <PrimeButton
        type="primary"
        disabled={disableSave}
        onClick={() => onOpenModal("add-preset")}
      >
        Save Current View as Preset
      </PrimeButton>
    }
    {onResetPreset &&
      <PrimeButton
        type="link"
        onClick={onResetPreset}
      >
        Reset View
      </PrimeButton>
    }
  </div>
}

PresetFooterActions.propTypes = {
  disableSave: PropTypes.bool,
  onOpenModal: PropTypes.func,
  onResetPreset: PropTypes.func,
}

export default PresetFooterActions